import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid py-4" }
const _hoisted_2 = { class: "row starter-main mt-5 pt-5" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "card border-0 shadow-sm" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "d-flex justify-content-end align-items-center gap-3 mt-3 mb-2" }
const _hoisted_9 = { class: "d-flex align-items-center gap-2" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "pagination-mini" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "px-2" }
const _hoisted_16 = { class: "mt-4 pt-3 border-top" }
const _hoisted_17 = {
  key: 0,
  class: "accordion",
  id: "modalPermissionsAccordion"
}
const _hoisted_18 = { class: "accordion-header" }
const _hoisted_19 = ["data-bs-target"]
const _hoisted_20 = { class: "badge bg-info ms-2 text-white" }
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "accordion-body p-0" }
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "table table-hover mb-0" }
const _hoisted_25 = { class: "ps-3 align-middle border-0" }
const _hoisted_26 = { class: "fw-500" }
const _hoisted_27 = { class: "text-center align-middle border-0" }
const _hoisted_28 = ["onUpdate:modelValue", "disabled"]
const _hoisted_29 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_30 = { class: "text-center align-middle border-0" }
const _hoisted_31 = ["onUpdate:modelValue", "disabled"]
const _hoisted_32 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_33 = { class: "text-center align-middle border-0" }
const _hoisted_34 = ["onUpdate:modelValue", "disabled"]
const _hoisted_35 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_36 = { class: "text-center align-middle border-0" }
const _hoisted_37 = ["onUpdate:modelValue", "disabled"]
const _hoisted_38 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_39 = {
  key: 1,
  class: "text-center py-4 text-muted border rounded bg-light"
}
const _hoisted_40 = {
  key: 0,
  class: "spinner-border spinner-border-sm mb-2"
}
const _hoisted_41 = { class: "mb-0" }

import { ref, computed, onMounted, watch, reactive } from "vue";
import { useCrud } from "@/composables/commen/useCrud";
import BaseModal from "@/components/commen/modal/BaseModal.vue";
import BaseForm, { FormField } from "@/components/commen/modal/BaseForm.vue";
import CommonTable2 from "@/components/commen/table/CommonTable2.vue";
import { usePermissions } from "@/composables/usePermissions";
import apiService from "@/services/apiService";
import { toast, Content } from "vue3-toastify";


const __default__ = {
  name: "CMSRolesAndPermissions",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { canCreate, canUpdate } = usePermissions();
const ROLES_API = "/cms-roles-permissions/roles";
const PERMS_API = "/cms-roles-permissions/permissions";

const crud = useCrud(ROLES_API);

// --- State Management ---
const rows = ref<any[]>([]);
const isModalOpen = ref(false);
const isViewMode = ref(false);
const isEditMode = ref(false);
const formItemData = ref({ title: "" });
const currentRoleId = ref<string | null>(null);
const allPermissions = ref<any[]>([]);
const rolePermissionsMap = reactive<Record<string, any>>({});

const modalId = computed(() => isEditMode.value ? "editRoleModal" : "createRoleModal");
const modalTitle = computed(() => {
  if (isViewMode.value) return "View Role Details";
  if (isEditMode.value) return "Edit Role & Permissions";
  return "Create New Role";
});

const tableConfig = ref({
  columns: [
    { name: "Title", field: "title", sortable: true },
    { name: "Permissions Count", field: "perms_count", sortable: false },
    { name: "Created At", field: "createdAt", sortable: true },
  ],
  data: rows,
  actions: [true],
  loading: crud.isLoading,
  table_width: "max-content",
});

const tablePagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0,
  total_pages: 0,
  has_next: false,
  has_prev: false,
});

const visiblePages = computed(() => {
  const total = tablePagination.value.total_pages;
  const current = tablePagination.value.current_page;
  if (!total || total <= 4) return Array.from({ length: Math.max(1, total) }, (_, i) => i + 1);
  const pages = [];
  pages.push(1);
  if (current > 4) pages.push("...");
  const windowStart = Math.max(2, current - 1);
  const windowEnd = Math.min(total - 1, current + 1);
  for (let i = windowStart; i <= windowEnd; i++) pages.push(i);
  if (current < total - 3) pages.push("...");
  pages.push(total);
  return pages;
});

const roleFormFields = computed<FormField[]>(() => [
  {
    key: "title",
    label: "Role Title",
    type: "text",
    required: true,
    placeholder: "Enter role title (e.g. Editor)",
    readonly: isViewMode.value,
  },
]);

// --- Watchers ---
watch(crud.data, (newVal) => {
  rows.value = (newVal || []).map((role: any) => ({
    ...role,
    perms_count: Array.isArray(role.permissions) ? role.permissions.filter((p: any) => 
        p.is_view || p.is_create || p.is_update || p.is_delete
    ).length : 0,
    createdAt: role.createdAt || role.created_at,
  }));
});

watch(() => crud.pagination.value, (newVal) => {
  if (!newVal) return;
  tablePagination.value.current_page = newVal.current_page || 1;
  tablePagination.value.total_pages = newVal.total_pages || 1;
  tablePagination.value.total = newVal.total || 0;
  tablePagination.value.has_prev = tablePagination.value.current_page > 1;
  tablePagination.value.has_next = tablePagination.value.current_page < tablePagination.value.total_pages;
}, { immediate: true, deep: true });

// --- Methods ---
const initPermissionsMap = (roleData?: any) => {
  // Clear the map
  Object.keys(rolePermissionsMap).forEach(key => delete rolePermissionsMap[key]);

  // 1. Initialize all from master list with false
  allPermissions.value.forEach(p => {
    rolePermissionsMap[p._id] = {
      is_view: false,
      is_create: false,
      is_update: false,
      is_delete: false
    };
  });

  // 2. Overlay role-specific permissions
  if (roleData && Array.isArray(roleData.permissions)) {
    roleData.permissions.forEach((rp: any) => {
      // Find matching permission from master list based on module ID or permission ID
      const rpModuleId = rp.cms_module_id?._id || rp.cms_module_id || rp._id;
      
      const masterPerm = allPermissions.value.find(mp => 
        (mp.cms_module_id?._id === rpModuleId) || 
        (mp.cms_module_id === rpModuleId) ||
        (mp._id === rpModuleId) ||
        (mp._id === rp._id)
      );

      const targetId = masterPerm ? masterPerm._id : rp._id;

      if (rolePermissionsMap[targetId]) {
         rolePermissionsMap[targetId].is_view = !!rp.is_view;
         rolePermissionsMap[targetId].is_create = !!rp.is_create;
         rolePermissionsMap[targetId].is_update = !!rp.is_update;
         rolePermissionsMap[targetId].is_delete = !!rp.is_delete;
      }
    });
  }
};

const groupedPermissions = computed(() => {
  const groups: Record<string, any[]> = {};
  
  // ALWAYS use master list for grouping so UI shows all modules!
  allPermissions.value.forEach(perm => {
    let moduleName = perm.module_name || perm.title || "General";
    
    // Check if module info exists in the master permission record or is directly available
    if (perm.cms_module_id && perm.cms_module_id.title) {
        moduleName = perm.cms_module_id.title;
    } else if (perm.title && !perm.module_name) {
        const guessed = perm.title.split(' Access')[0];
        moduleName = guessed;
    }

    if (!groups[moduleName]) groups[moduleName] = [];
    groups[moduleName].push(perm);
  });
  
  return groups;
});

const openCreateModal = () => {
  isViewMode.value = false;
  isEditMode.value = false;
  currentRoleId.value = null;
  formItemData.value = { title: "" };
  initPermissionsMap();
  isModalOpen.value = true;
};

const handleEdit = (row: any) => {
  isViewMode.value = false;
  isEditMode.value = true;
  currentRoleId.value = row._id;
  formItemData.value = { title: row.title };
  initPermissionsMap(row);
  isModalOpen.value = true;
};

const handleView = (row: any) => {
  isViewMode.value = true;
  isEditMode.value = true;
  currentRoleId.value = row._id;
  formItemData.value = { title: row.title };
  initPermissionsMap(row);
  isModalOpen.value = true;
};

const closeModal = () => {
  isModalOpen.value = false;
  isViewMode.value = false;
  isEditMode.value = false;
  currentRoleId.value = null;
  formItemData.value = { title: "" };
};

const handleSave = async () => {
  // Transform map back to array of objects
  const permissionsPayload = Object.entries(rolePermissionsMap).map(([permId, value]) => {
    // We need to find the module ID associated with this permission.
    // Try finding it in allPermissions (master list)
    const masterPerm = allPermissions.value.find(p => p._id === permId);
    
    // Resolve the module ID. It might be in p.cms_module_id._id or p.cms_module_id (as string)
    let moduleId = null;
    if (masterPerm) {
      moduleId = typeof masterPerm.cms_module_id === 'object' ? masterPerm.cms_module_id?._id : masterPerm.cms_module_id;
    }

    // Default to permId if module_id not found or if creating fallback
    if (!moduleId) {
        moduleId = permId; 
    }

    return {
      _id: moduleId,
      is_view: value.is_view,
      is_create: value.is_create,
      is_update: value.is_update,
      is_delete: value.is_delete,
    };
  });

  const payload = {
    title: formItemData.value.title,
    permissions: permissionsPayload
  };

  if (isEditMode.value && currentRoleId.value) {
    const result = await crud.updateItem(currentRoleId.value, payload);
    if (result) {
      closeModal();
      await crud.fetchData();
    }
  } else {
    const result = await crud.createItem(payload);
    if (result) {
      closeModal();
      await crud.fetchData();
    }
  }
};

const handleDelete = async (id: string) => {
  if (confirm("Are you sure you want to delete this role?")) {
    await crud.deleteItem(id);
    await crud.fetchData();
  }
};

const changeRows = async () => {
  await crud.fetchData({ page: 1, limit: tablePagination.value.per_page });
};

const handlePageChange = async (page: number) => {
  if (page < 1 || page === tablePagination.value.current_page) return;
  await crud.fetchData({ page, limit: tablePagination.value.per_page });
};

const fetchPermissions = async () => {
  try {
    const res = await apiService.get(PERMS_API);
    allPermissions.value = (res.data || res).filter((p: any) => !p.is_trash);
    initPermissionsMap(); // Pre-initialize mapping to avoid undefined templates
  } catch (err) {
    console.error("Error fetching permissions:", err);
  }
};

onMounted(async () => {
  await crud.fetchData();
  await fetchPermissions();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "mb-0" }, "CMS Roles Management", -1)),
            _createElementVNode("button", {
              class: "btn btn-primary btn-sm",
              onClick: openCreateModal,
              disabled: !_unref(canCreate)('settings')
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
              _createTextVNode(" Create Role ", -1)
            ]))], 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(CommonTable2, {
                tableObj: tableConfig.value,
                title: 'CMS Roles',
                onEdit: handleEdit,
                onDelete: handleDelete,
                onView: handleView,
                permissionKey: "settings"
              }, null, 8, ["tableObj"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-muted" }, "Rows per page:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm rows-select",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tablePagination.value.per_page) = $event)),
                    onChange: changeRows
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 20, 50, 100], (n) => {
                      return _createElementVNode("option", {
                        key: n,
                        value: n
                      }, _toDisplayString(n), 9, _hoisted_10)
                    }), 64))
                  ], 544), [
                    [_vModelSelect, tablePagination.value.per_page]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "page-btn prev_btn",
                    disabled: !tablePagination.value.has_prev,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePageChange(tablePagination.value.current_page - 1)))
                  }, "«", 8, _hoisted_12),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, index) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: index,
                      class: _normalizeClass(["page-btn", { 'page-active': p === tablePagination.value.current_page }]),
                      disabled: p === '...',
                      onClick: ($event: any) => (p !== '...' && typeof p === 'number' && handlePageChange(p))
                    }, _toDisplayString(p), 11, _hoisted_13))
                  }), 128)),
                  _createElementVNode("button", {
                    class: "page-btn next_btn",
                    disabled: !tablePagination.value.has_next,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePageChange(tablePagination.value.current_page + 1)))
                  }, "»", 8, _hoisted_14)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(BaseModal, {
      id: modalId.value,
      title: modalTitle.value,
      visible: isModalOpen.value,
      onClose: closeModal,
      onSave: handleSave,
      "show-save-button": !isViewMode.value,
      size: "lg"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(BaseForm, {
            fields: roleFormFields.value,
            modelValue: formItemData.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formItemData).value = $event)),
            onSubmit: handleSave
          }, null, 8, ["fields", "modelValue"]),
          _createElementVNode("div", _hoisted_16, [
            _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "mb-3 d-flex align-items-center" }, [
              _createElementVNode("i", { class: "fas fa-shield-alt me-2 text-primary" }),
              _createTextVNode(" Manage Permissions ")
            ], -1)),
            (allPermissions.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedPermissions.value, (perms, moduleName) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: moduleName,
                      class: "accordion-item shadow-none border mb-2"
                    }, [
                      _createElementVNode("h2", _hoisted_18, [
                        _createElementVNode("button", {
                          class: "accordion-button collapsed py-2 px-3 fw-bold",
                          type: "button",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": `#coll-mod-${moduleName.replace(/[^a-zA-Z0-9]/g, '')}`
                        }, [
                          _createTextVNode(_toDisplayString(moduleName) + " ", 1),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(perms.length), 1)
                        ], 8, _hoisted_19)
                      ]),
                      _createElementVNode("div", {
                        id: `coll-mod-${moduleName.replace(/[^a-zA-Z0-9]/g, '')}`,
                        class: "accordion-collapse collapse",
                        "data-bs-parent": "#modalPermissionsAccordion"
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("table", _hoisted_24, [
                              _cache[7] || (_cache[7] = _createElementVNode("thead", { class: "table-light" }, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "ps-3 border-0" }, "Permission"),
                                  _createElementVNode("th", {
                                    class: "text-center border-0",
                                    style: {"width":"80px"}
                                  }, "View"),
                                  _createElementVNode("th", {
                                    class: "text-center border-0",
                                    style: {"width":"80px"}
                                  }, "Create"),
                                  _createElementVNode("th", {
                                    class: "text-center border-0",
                                    style: {"width":"80px"}
                                  }, "Edit"),
                                  _createElementVNode("th", {
                                    class: "text-center border-0",
                                    style: {"width":"80px"}
                                  }, "Delete")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(perms, (perm) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: perm._id
                                  }, [
                                    _createElementVNode("td", _hoisted_25, [
                                      _createElementVNode("span", _hoisted_26, _toDisplayString(perm.title), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_27, [
                                      (perm.is_view !== undefined && rolePermissionsMap[perm._id])
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 0,
                                            type: "checkbox",
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event: any) => ((rolePermissionsMap[perm._id].is_view) = $event),
                                            disabled: isViewMode.value || !_unref(canUpdate)('settings')
                                          }, null, 8, _hoisted_28)), [
                                            [_vModelCheckbox, rolePermissionsMap[perm._id].is_view]
                                          ])
                                        : (_openBlock(), _createElementBlock("span", _hoisted_29, "—"))
                                    ]),
                                    _createElementVNode("td", _hoisted_30, [
                                      (perm.is_create !== undefined && rolePermissionsMap[perm._id])
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 0,
                                            type: "checkbox",
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event: any) => ((rolePermissionsMap[perm._id].is_create) = $event),
                                            disabled: isViewMode.value || !_unref(canUpdate)('settings')
                                          }, null, 8, _hoisted_31)), [
                                            [_vModelCheckbox, rolePermissionsMap[perm._id].is_create]
                                          ])
                                        : (_openBlock(), _createElementBlock("span", _hoisted_32, "—"))
                                    ]),
                                    _createElementVNode("td", _hoisted_33, [
                                      (perm.is_update !== undefined && rolePermissionsMap[perm._id])
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 0,
                                            type: "checkbox",
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event: any) => ((rolePermissionsMap[perm._id].is_update) = $event),
                                            disabled: isViewMode.value || !_unref(canUpdate)('settings')
                                          }, null, 8, _hoisted_34)), [
                                            [_vModelCheckbox, rolePermissionsMap[perm._id].is_update]
                                          ])
                                        : (_openBlock(), _createElementBlock("span", _hoisted_35, "—"))
                                    ]),
                                    _createElementVNode("td", _hoisted_36, [
                                      (perm.is_delete !== undefined && rolePermissionsMap[perm._id])
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 0,
                                            type: "checkbox",
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event: any) => ((rolePermissionsMap[perm._id].is_delete) = $event),
                                            disabled: isViewMode.value || !_unref(canUpdate)('settings')
                                          }, null, 8, _hoisted_37)), [
                                            [_vModelCheckbox, rolePermissionsMap[perm._id].is_delete]
                                          ])
                                        : (_openBlock(), _createElementBlock("span", _hoisted_38, "—"))
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ], 8, _hoisted_21)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (_unref(crud).isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_41, _toDisplayString(_unref(crud).isLoading ? 'Loading permissions...' : 'No permissions found.'), 1)
                ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["id", "title", "visible", "show-save-button"])
  ], 64))
}
}

})